import React from "react";
import styled from "styled-components";
import { Row } from "@ui/components/layout";

interface WorkspaceLabelProps extends React.HTMLAttributes<HTMLDivElement> {
	workspace: string;
	selected?: boolean;
}
export const WorkspaceLabel: React.FC<WorkspaceLabelProps> = ({ workspace, selected = false, ...htmlProps }) => {
	return (
		<Container selected={selected} {...htmlProps}>
			<Row gap={4} align="center">
				<Cercle selected={selected} />
				{workspace}
			</Row>
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>`
	cursor: pointer;
	background-color: ${({ theme, selected }) => (selected ? theme.colors.tertiaryblue : theme.colors.lightergray)};
	border-radius: 50px;
	padding: 9px 12px 7px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme, selected }) => (selected ? theme.colors.secondary : theme.colors.gray)};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: auto;
`;

const Cercle = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>`
	background-color: ${({ theme, selected }) => (selected ? theme.colors.secondary : theme.colors.gray)};
	height: 15px;
	width: 15px;
	margin-right: 5px;
	border-radius: 8px;
`;
